import {
  PrimaryCategory,
  type PrimaryCategoryConstructor,
} from '../PrimaryCategory'
import {
  SecondaryCategory,
  type SecondaryCategoryConstructor,
} from '../SecondaryCategory'
import { User, type UserConstructorData } from '../User'

export interface RequesterConstructor extends UserConstructorData {
  primaryCategory: Nullable<PrimaryCategoryConstructor>
  secondaryCategory: Nullable<SecondaryCategoryConstructor>
}

export class Requester extends User {
  primaryCategory: Nullable<PrimaryCategory>
  secondaryCategory: Nullable<SecondaryCategory>

  constructor(data: RequesterConstructor) {
    super(data)

    this.primaryCategory = data.primaryCategory
      ? new PrimaryCategory({
          id: data.primaryCategory.id,
          name: data.primaryCategory.name,
        })
      : null

    this.secondaryCategory = data.secondaryCategory
      ? new SecondaryCategory({
          id: data.secondaryCategory.id,
          name: data.secondaryCategory.name,
          primaryCategory: data.secondaryCategory.primaryCategory,
        })
      : null
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }
}
